/* Year One theme — ported from the v5 prototype.
   Quick view: each live card on the shop grid ships a <template> with its full product panel
   (rendered by Liquid). Opening a card clones that template into #lb. The same panel is
   rendered in-page on /products/<handle>, so every binding below works in both places.   */
(function () {
  'use strict';
  var $ = function (id) { return document.getElementById(id); };
  var lb = $('lb'), fb = $('fb');
  var lastFocus = null;

  /* ---------- giveaway form → its own endpoint (Apps Script from giveaways@) ---------- */
  (function () {
    var f = $('giveawayForm'); if (!f) return;
    var url = f.getAttribute('data-endpoint'); if (!url) return;      /* no endpoint: plain Shopify contact form */
    var err = f.querySelector('[data-err]'), btn = f.querySelector('.gw__btn');
    f.addEventListener('submit', function (ev) {
      ev.preventDefault();
      if (!f.checkValidity()) { f.reportValidity(); return; }
      var fd = new FormData();
      f.querySelectorAll('input[name^="contact["]').forEach(function (i) {
        if (i.type === 'checkbox' && !i.checked) return;
        fd.append(i.name.replace(/^contact\[(.+)\]$/, '$1'), i.value);
      });
      var hp = f.querySelector('input[name="website"]'); if (hp) fd.append('website', hp.value);
      fd.append('ua', navigator.userAgent);
      btn.disabled = true; var label = btn.textContent; btn.textContent = 'Sending…'; err.hidden = true;
      fetch(url, { method: 'POST', body: fd })
        .then(function (r) { return r.json(); })
        .then(function (res) {
          if (!res || !res.ok) throw new Error(res && res.error === 'missing' ? 'Please fill in every field and tick both boxes.' : 'Something went wrong — please try again.');
          f.innerHTML = '<div class="gw__done"><p class="gw__eyebrow">Giveaway</p><h2 class="gw__card-h">' + (f.getAttribute('data-success-heading') || "You're in.") + '</h2><p class="gw__muted">' + (f.getAttribute('data-success-message') || 'Your entry is logged.') + '</p></div>';
        })
        .catch(function (e) {
          btn.disabled = false; btn.textContent = label;
          err.textContent = e.message || 'Something went wrong — please try again, or email giveaways@yearonegoods.com.'; err.hidden = false;
        });
    });
  })();

  /* ---------- reveal on scroll ---------- */
  var io = new IntersectionObserver(function (es) {
    es.forEach(function (x) { if (x.isIntersecting) { x.target.classList.add('in'); io.unobserve(x.target); } });
  }, { threshold: .12 });
  document.querySelectorAll('.rv').forEach(function (el, i) { el.style.transitionDelay = (i % 6 * 55) + 'ms'; io.observe(el); });

  /* ---------- grid / list toggle ---------- */
  var cards = $('cards'), vG = $('vGrid'), vL = $('vList');
  if (cards && vG && vL) {
    var setView = function (list) {
      cards.classList.toggle('is-list', list);
      vG.setAttribute('aria-pressed', String(!list));
      vL.setAttribute('aria-pressed', String(list));
    };
    vG.addEventListener('click', function () { setView(false); });
    vL.addEventListener('click', function () { setView(true); });
  }

  /* ---------- product panel bindings (quick view + product page) ---------- */
  function bindPanel(panel) {
    var frames = Array.prototype.slice.call(panel.querySelectorAll('.lbimg'));
    var tabs = Array.prototype.slice.call(panel.querySelectorAll('.lb__thumbs button'));
    tabs.forEach(function (b) {
      b.addEventListener('click', function () {
        var n = +b.getAttribute('data-frame');
        frames.forEach(function (x, k) { x.classList.toggle('on', k === n); });
        tabs.forEach(function (x, k) { x.setAttribute('aria-current', k === n ? 'true' : 'false'); });
      });
    });
    panel.querySelectorAll('.acc__btn').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var open = btn.getAttribute('aria-expanded') === 'true';
        btn.setAttribute('aria-expanded', open ? 'false' : 'true');
        btn.nextElementSibling.classList.toggle('on', !open);
      });
    });
    var sizes = panel.querySelector('.sizes');
    var add = panel.querySelector('[data-add]');
    var buy = panel.querySelector('[data-buy]');
    var msg = panel.querySelector('[data-msg]');
    var chosen = null;
    if (sizes) {
      sizes.querySelectorAll('.size').forEach(function (b) {
        b.addEventListener('click', function () {
          sizes.querySelectorAll('.size').forEach(function (c) { c.setAttribute('aria-pressed', 'false'); });
          b.setAttribute('aria-pressed', 'true');
          chosen = b.getAttribute('data-variant');
          if (msg) { msg.hidden = true; }
          if (add && add.classList.contains('is-added')) { add.classList.remove('is-added'); add.textContent = 'Add to cart'; }
        });
      });
    }
    /* true (and nudges the shopper) when no size has been picked yet */
    function needSize() {
      if (chosen) return false;
      if (msg) { msg.textContent = 'Pick a size first.'; msg.hidden = false; }
      var first = sizes && sizes.querySelector('.size:not([disabled])');
      if (first) first.focus();
      return true;
    }
    function addToCart() {
      return fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: +chosen, quantity: 1 }] })
      }).then(function (r) { return r.json().then(function (j) { return { ok: r.ok, body: j }; }); })
        .then(function (res) {
          if (!res.ok) { throw new Error(res.body && (res.body.description || res.body.message) || 'Could not add to cart'); }
          return res.body;
        });
    }
    function setBusy(on) { if (add) add.disabled = on; if (buy) buy.disabled = on; }
    if (add) {
      add.addEventListener('click', function () {
        if (add.disabled || needSize()) return;
        setBusy(true); add.textContent = 'Adding…';
        addToCart()
          .then(function () {
            setBusy(false); add.textContent = 'Added to cart'; add.classList.add('is-added');
            if (msg) { msg.innerHTML = 'Added to your cart. <a href="/cart">View cart</a> or pick another size.'; msg.hidden = false; }
            return fetch('/cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); })
              .then(function (cart) { var n = $('bagN'); if (n) n.textContent = cart.item_count; });
          })
          .catch(function (e) {
            setBusy(false); add.textContent = 'Add to cart';
            if (msg) { msg.textContent = e.message; msg.hidden = false; }
          });
      });
    }
    /* Buy now: add the pair, then go straight to checkout */
    if (buy) {
      buy.addEventListener('click', function () {
        if (buy.disabled || needSize()) return;
        setBusy(true); buy.textContent = 'One moment…';
        addToCart()
          .then(function () { window.location.href = '/checkout'; })
          .catch(function (e) {
            setBusy(false); buy.textContent = 'Buy now';
            if (msg) { msg.textContent = e.message; msg.hidden = false; }
          });
      });
    }
  }

  /* ---------- edition choice: two products in one panel ---------- */
  function bindChoice(box) {
    var chips = box.querySelectorAll('.pch__chip');
    chips.forEach(function (c) {
      c.addEventListener('click', function () {
        var target = c.getAttribute('data-target');
        chips.forEach(function (x) { x.setAttribute('aria-selected', x.getAttribute('data-target') === target ? 'true' : 'false'); });
        box.querySelectorAll('.pch__panel').forEach(function (p) { p.hidden = p.id !== target; });
        var shown = box.querySelector('#' + target); if (shown && shown.scrollIntoView) shown.scrollIntoView({ block: 'nearest' });
      });
    });
  }
  document.querySelectorAll('main [data-choice]').forEach(bindChoice);

  /* ---------- quick view lightbox ---------- */
  function openQV(id, toSizes) {
    var tpl = document.getElementById(id);
    if (!tpl || !lb) return;
    lastFocus = document.activeElement;
    lb.innerHTML = '';
    lb.appendChild(tpl.content.cloneNode(true));
    var panels = lb.querySelectorAll('[data-product-panel]');
    panels.forEach(bindPanel);
    lb.querySelectorAll('[data-choice]').forEach(bindChoice);
    var panel = panels[0];
    lb.classList.add('on'); document.body.style.overflow = 'hidden';
    var x = panel.querySelector('[data-close-qv]');
    lb.querySelectorAll('[data-close-qv]').forEach(function (b) { b.addEventListener('click', closeQV); });
    if (toSizes) {
      var first = panel.querySelector('.size:not([disabled])');
      (first || panel.querySelector('[data-add]') || x).focus({ preventScroll: true });
      var s = panel.querySelector('.sizes'); if (s && s.scrollIntoView) s.scrollIntoView({ block: 'nearest' });
    } else if (x) { x.focus(); }
  }
  function closeQV() {
    if (!lb || !lb.classList.contains('on')) return;
    lb.classList.remove('on'); lb.innerHTML = ''; document.body.style.overflow = '';
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }
  document.addEventListener('click', function (e) {
    var q = e.target.closest('.qv');
    if (q) { e.stopPropagation(); openQV(q.getAttribute('data-qv'), true); return; }
    if (e.target.closest('[data-open-form]')) return;
    var card = e.target.closest('.pc[data-qv]');
    if (card) openQV(card.getAttribute('data-qv'));
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') { closeQV(); closeForm(); return; }
    if (e.key !== 'Enter' && e.key !== ' ') return;
    var card = e.target.closest && e.target.closest('.pc[data-qv]');
    if (card && e.target === card) { e.preventDefault(); openQV(card.getAttribute('data-qv')); }
  });
  if (lb) lb.addEventListener('click', function (e) { if (e.target === lb) closeQV(); });

  /* in-page product panel (product template) */
  document.querySelectorAll('main [data-product-panel]').forEach(bindPanel);

  /* ---------- hero: 4 frames, 0.60s each, shuffled, never the same twice running ---------- */
  (function () {
    var stage = $('heroStage'); if (!stage) return;
    var slides = Array.prototype.slice.call(stage.querySelectorAll('img'));
    if (slides.length < 2) return;
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    stage.classList.add('is-live');
    var queue = [], last = -1, timer = null;
    function refill() {
      queue = slides.map(function (_, i) { return i; });
      for (var i = queue.length - 1; i > 0; i--) { var j = Math.floor(Math.random() * (i + 1)), t = queue[i]; queue[i] = queue[j]; queue[j] = t; }
      if (queue[0] === last) { var e = queue.length - 1, s = queue[0]; queue[0] = queue[e]; queue[e] = s; }
    }
    function next() { if (!queue.length) refill(); var i = queue.shift(); slides.forEach(function (s, n) { s.classList.toggle('on', n === i); }); last = i; }
    function start() { if (!timer) timer = setInterval(next, 600); }
    function stop() { clearInterval(timer); timer = null; }
    next(); start();
    document.addEventListener('visibilitychange', function () { document.hidden ? stop() : start(); });
  })();

  /* ---------- waitlist / nominate / contact — Shopify contact form in a modal ---------- */
  var fbLast = null, fbMode = 'nominate';
  function openForm(mode, school, color) {
    if (!fb) return;
    fbLast = document.activeElement; fbMode = mode;
    var accent = color || 'var(--ink)';
    $('fbAccent').style.background = accent;
    $('fbEyebrow').style.color = accent;
    var form = $('fbForm'), done = $('fbDone'), row = $('fbSchoolRow');
    form.classList.remove('off'); done.classList.remove('on');
    $('fbErr').textContent = '';
    $('fbModeField').value = mode;
    if (mode === 'contact') {
      $('fbEyebrow').textContent = 'Contact';
      $('fbTitle').textContent = 'Get in touch';
      $('fbBlurb').textContent = 'Questions about sizing, an order, or a school we should be making? Send it over and we’ll come back to you.';
      row.style.display = 'none'; $('fbSchool').value = '';
      $('fbMsgLabel').textContent = 'How can we help?'; $('fbMsg').placeholder = 'Tell us what you need.';
    } else if (mode === 'waitlist') {
      $('fbEyebrow').textContent = 'Coming soon';
      $('fbTitle').textContent = 'Join the ' + school + ' waitlist';
      $('fbBlurb').textContent = 'We’ll email you the morning the ' + school + ' drop opens. Runs are small and sizes go in an afternoon.';
      row.style.display = ''; $('fbSchool').value = school; $('fbSchool').readOnly = true;
      $('fbMsgLabel').textContent = 'Anything else (optional)'; $('fbMsg').placeholder = "Size you're after, questions, anything.";
    } else {
      $('fbEyebrow').textContent = 'Nominate a school';
      $('fbTitle').textContent = 'Don’t see your school?';
      $('fbBlurb').textContent = 'Tell us which one. Schools with the most nominations get licensed first.';
      row.style.display = ''; $('fbSchool').value = ''; $('fbSchool').readOnly = false;
      $('fbMsgLabel').textContent = 'Anything else (optional)'; $('fbMsg').placeholder = "Size you're after, questions, anything.";
    }
    fb.classList.add('on'); document.body.style.overflow = 'hidden';
    $('fbX').focus();
  }
  function closeForm() {
    if (!fb || !fb.classList.contains('on')) return;
    fb.classList.remove('on'); document.body.style.overflow = '';
    if (fbLast && fbLast.focus) fbLast.focus();
  }
  if (fb) {
    $('fbForm').addEventListener('submit', function (ev) {
      var n = $('fbName').value.trim(), e = $('fbEmail').value.trim(), s = $('fbSchool').value.trim(), m = $('fbMsg');
      var fail = function (t, el) { ev.preventDefault(); $('fbErr').textContent = t; el.focus(); };
      if (!n) return fail('Add your name.', $('fbName'));
      if (e.indexOf('@') < 0 || e.indexOf('.') < 0) return fail('Check the email address.', $('fbEmail'));
      if (fbMode === 'contact') { if (!m.value.trim()) return fail('Add a message.', m); }
      else if (!s) return fail('Which school?', $('fbSchool'));
      /* Shopify requires a body — fill it in for waitlist and nominations that left it blank */
      if (!m.value.trim()) m.value = (fbMode === 'waitlist' ? 'Waitlist: ' : 'Nomination: ') + s;
      $('fbSend').textContent = 'Sending…';
    });
    $('fbX').addEventListener('click', closeForm);
    fb.addEventListener('click', function (ev) { if (ev.target === fb) closeForm(); });
    document.addEventListener('click', function (ev) {
      var t = ev.target.closest('[data-open-form]');
      if (!t) return;
      ev.preventDefault();
      openForm(t.getAttribute('data-open-form'), t.getAttribute('data-school') || '', t.getAttribute('data-color') || '');
    });
    /* back from a successful post: Shopify reloads the page with the form marked posted */
    if ($('fbPosted')) {
      $('fbAccent').style.background = 'var(--ink)';
      $('fbEyebrow').textContent = ''; $('fbTitle').textContent = 'Thank you'; $('fbBlurb').textContent = '';
      $('fbForm').classList.add('off'); $('fbDone').classList.add('on');
      $('fbDoneMsg').textContent = 'We have it. We’ll come back to you by email.';
      fb.classList.add('on'); document.body.style.overflow = 'hidden'; $('fbX').focus();
      if (history.replaceState) history.replaceState(null, '', location.pathname);
    }
  }
})();
